import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";

export const DeleteInvoiceWarningModal = ({
  onVoid,
  onDelete,
  isVoidLoading,
  isDeleteLoading,
}: {
  onVoid: (e?: React.MouseEvent) => void;
  onDelete: (e?: React.MouseEvent) => void;
  isVoidLoading?: boolean;
  isDeleteLoading?: boolean;
}) => {
  return (
    <>
      <Modal.Content>
        <StatusModal type="warning" title="Delete invoice?">
          <div className="t-text-body-sm t-space-y-3">
            <div>
              This action is irreversible. Deleting this invoice will also
              delete all related journal entries and will impact your
              financials.
            </div>
            <div className="t-italic t-text-body-sm ">
              To keep your live financials unchanged, consider voiding the
              invoice. Voiding automatically creates a reversal journal entry
              for it.
            </div>
          </div>
        </StatusModal>
        <Modal.Footer>
          <div className="t-flex t-gap-2 t-justify-end">
            <Button onClick={onVoid} isLoading={isVoidLoading}>
              Void sent invoices
            </Button>
            <Button
              customType="primary"
              onClick={onDelete}
              isLoading={isDeleteLoading}
            >
              Delete
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </>
  );
};
